/**
 * Router context.
 */

import type { Router, State } from 'router5'

class Context {
  router5: Router | null = null

  CONTEXT_CHANGED = 'context_changed'

  setRouter5 = (router5: Router) => {
    this.router5 = router5
  }

  swoopContext = () => this.router5?.getState()?.path || ''

  navigate = (routeName: string, params: Record<string, string> | null = null) => {
    // remove leading # and /
    const cleanedRouteName = routeName.replace(/^[#/]+/, '')
    this.router5?.navigate(cleanedRouteName, params as Record<string, string>)
  }

  /**
   * Remove param from URL without refresh.
   */

  deleteParam = (param: string) => {
    const route = this.router5?.getState() as State
    delete route.params[param]
    this.router5?.replaceHistoryState(route.name, route.params)
  }

  /**
   * Replace param (URL state) without refresh.
   */

  replaceParam = (oldParam: string, newParam: string, value: string | null = null) => {
    const route = this.router5?.getState() as State
    delete route.params[oldParam]
    route.params[newParam] = value
    this.router5?.replaceHistoryState(route.name, route.params)
  }
}

const context = new Context()

export default context
